import {
  Alert,
  AlertTitle,
  Box,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { DbLead } from '../../../../shared/types/leads';
import { formatDateTolocaleDateString } from '../../utils/formatDateTimes';
import MessageIcon from '@mui/icons-material/Message';
import { Warning } from '@mui/icons-material';
import DefaultTooltip from '../Tooltips/DefaultTooltip';

type LeadViewProps = DbLead;

const LeadView = ({ lead }: { lead: LeadViewProps }) => {
  return (
    <>
      <h3 style={{ color: 'black' }}>Tarjouspyynnön tiedot</h3>
      <TableContainer>
        <Table size="small">
          <TableBody>
            {[
              { key: 'Etunimi', value: lead.firstName },
              { key: 'Sukunimi', value: lead.lastName },
              { key: 'Sähköposti', value: lead.emailAddress },
              { key: 'Yrityksen nimi', value: lead.companyName },
              { key: 'Puhelinnumero', value: lead.telephone },
              {
                key: 'Katuosoite',
                value: lead.deliveryStreetAddress,
              },
              { key: 'Paikkakunta', value: lead.deliveryCity },
              {
                key: 'Lähin toimipiste',
                value: lead.nearestOfficeId,
              },
              {
                key: 'Tarjouksen lisätietoja',
                value: lead.offerRequestInformation,
              },
              {
                key: 'Toimituspäivä',
                value:
                  lead.deliveryDay &&
                  formatDateTolocaleDateString(lead.deliveryDay),
              },
              {
                key: 'Haluttu nouto-/toimitusaika',
                value: lead.deliveryOrPickupTime,
              },
              { key: 'Toimitustapa', value: lead.pickupOrDelivery },
              {
                key: 'Arvioitu vuokra-aika',
                value:
                  lead.rentalEndingDay &&
                  formatDateTolocaleDateString(lead.rentalEndingDay),
              },
            ].map(({ key, value }) => {
              return (
                <TableRow>
                  <TableCell>{key}</TableCell>
                  <TableCell>{value}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <Alert
        sx={{ my: 2 }}
        severity="info"
        iconMapping={{
          info: <MessageIcon fontSize="inherit" />,
        }}
      >
        <AlertTitle>Tarjouspyynnön lisätietoja</AlertTitle>
        <i>{lead?.offerRequestInformation ?? '-'}</i>
      </Alert>
      <h3 style={{ color: 'black' }}>Tuotteet</h3>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              {[
                'CatClass',
                'Nimi',
                'Määrä',
                'Hinnoitteluperuste',
                'Hinta',
              ].map((cell) => (
                <TableCell key={cell} style={{ fontWeight: 'bold' }}>
                  {cell}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {lead.leadProducts.map((product) => {
              return (
                <TableRow key={product.catClass}>
                  <TableCell>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyItems: 'center',
                      }}
                    >
                      {product.catClass}
                      {!product.isTransformed && (
                        <DefaultTooltip
                          title={
                            'Tuotetta ei ole siirretty tarjoukselle automaattisesti'
                          }
                          placement={'top'}
                        >
                          <SvgIcon
                            color="error"
                            sx={{
                              fontSize: 16,
                              ml: 1,
                            }}
                            component={Warning}
                          />
                        </DefaultTooltip>
                      )}
                    </Box>
                  </TableCell>
                  <TableCell align="left">
                    {product.catClassName}
                  </TableCell>
                  <TableCell align="left">{product.amount}</TableCell>
                  <TableCell align="left">
                    {product.pricingBasis === 'DAY'
                      ? 'Päivä'
                      : 'Kuukausi'}
                  </TableCell>
                  <TableCell align="left">{product.price}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default LeadView;
